// extracted by mini-css-extract-plugin
module.exports = {"content":"content-sYsKCTwt4u"};